import React, { Dispatch, SetStateAction } from "react";

export function useSessionStorage(
  key: string,
  initialValue: string = ""
): [string, Dispatch<SetStateAction<string>>, () => void] {
  const getKey = (key: string) => {
    return `${process.env.REACT_APP_VERSION}_${key}`;
  };

  const [item, setValue] = React.useState(() => {
    const customKey = getKey(key);
    const value = sessionStorage.getItem(customKey) || initialValue;
    sessionStorage.setItem(customKey, value);

    return value;
  });

  const setItem = (action: SetStateAction<string>) => {
    const customKey = getKey(key);

    if (action instanceof Function) {
      return setValue((prevState) => {
        const value = action(prevState);
        sessionStorage.setItem(customKey, value);
        return value;
      });
    }
    setValue(action);
    sessionStorage.setItem(customKey, action);
  };

  const clear = () => {
    const customKey = getKey(key);
    sessionStorage.removeItem(customKey);
  };

  return [item, setItem, clear];
}

export function useSessionStorageWithObject<T>(
  key: string,
  initialValue: T
): [T, Dispatch<SetStateAction<T>>, () => void] {
  const [state, setState, clear] = useSessionStorage(
    key,
    JSON.stringify(initialValue)
  );
  const item: T = JSON.parse(state);
  const setItem = (value: SetStateAction<T>) => {
    if (value instanceof Function) {
      setState((prevState) => JSON.stringify(value(JSON.parse(prevState))));
      return;
    }
    setState(JSON.stringify(value));
  };
  return [item, setItem, clear];
}
